<input
  data-private
  [(ngModel)]="value"
  (ngModelChange)="modelChange()"
  (blur)="onTouched()"
  [disabled]="isDisabled$ | async"
  pKeyFilter="int"
  class="txt-box form-control p-inputtext"
  maxlength="10"
  [id]="inputId()"
/>
